import { AsyncJobType } from '@recruitee/account-data';
import { bulkActionFactory } from '@recruitee/async-job-data';
import { BulkOfferResponse } from '@recruitee/http/types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

import { Ids } from './bulk-actions-http-client';

const idSelector = ({ uuid }: BulkOfferResponse) => uuid;
const { actions, namespace, reducer, selectors } = createEntityCollectionStore<BulkOfferResponse>()(
  'offer-bulk-actions',
  {
    idSelector,
    customActions: adapter => {
      const getActions = bulkActionFactory(adapter);
      return {
        ...getActions('follow', AsyncJobType.BulkOffersFollow)<Ids>(),
        ...getActions('unfollow', AsyncJobType.BulkOffersUnfollow)<Ids>(),
        ...getActions('deleteArchived', AsyncJobType.BulkOffersDeleteArchived)<Ids>(),
        ...getActions('retrieveArchived', AsyncJobType.BulkOffersRetrieveArchived)<Ids>(),
        ...getActions('enableReferrals', AsyncJobType.BulkOffersEnableReferralProgram)<Ids>(),
        ...getActions('disableReferrals', AsyncJobType.BulkOffersDisableReferralProgram)<Ids>(),
      };
    },
  },
);

const OfferBulkActions = <
  Pick<
    typeof actions,
    | 'follow'
    | 'followSuccess'
    | 'followFailed'
    | 'unfollow'
    | 'unfollowSuccess'
    | 'unfollowFailed'
    | 'deleteArchived'
    | 'deleteArchivedSuccess'
    | 'deleteArchivedFailed'
    | 'retrieveArchived'
    | 'retrieveArchivedSuccess'
    | 'retrieveArchivedFailed'
    | 'enableReferrals'
    | 'enableReferralsSuccess'
    | 'enableReferralsFailed'
    | 'disableReferrals'
    | 'disableReferralsSuccess'
    | 'disableReferralsFailed'
  >
>actions;

export {
  OfferBulkActions,
  selectors as OfferBulkSelectors,
  reducer as OfferBulkReducer,
  namespace as OfferBulkNamespace,
};
